$(document).on 'turbolinks:load', ->
  $('#js-construction-site-details-download-pdf').on 'click', -> 
    window.print()